/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { toast } from 'react-toastify';
// API
import { getTeamFilter, getRepFilter, getGroupFilter } from '../../../api/filterOptionsApi';
// // Helper Functions
// import {
//   filterValue,
//   filterTeamOptions,
//   filterRepOptions,
//   filterGroupOptions,
// } from '../../../helpers/filterFunctions';
// Context
import useCcoContext from '../context/useCcoContext';

export default function Filter() {
  const { filterForm, setFilterForm, handleGenerateFilter, handleClearFilter } =
    useContext(useCcoContext);

  // const [teamOptions, setTeamOptions] = useState([]);
  // const [repOptions, setRepOptions] = useState([]);

  // const loadTeamDropdown = async () => {
  //   const request = {
  //     group: filterValue(filterForm?.group),
  //     rep_id: filterValue(filterForm?.rep_id),
  //     date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
  //     date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
  //   };
  //   const reponse = await getTeamFilter(request);
  //   const { code, data } = reponse.data;
  //   if (code === '200') {
  //     const dropdownValue = filterTeamOptions(data);

  //     setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
  //   }
  // };

  // const loadRepDropdown = async () => {
  //   const request = {
  //     team: filterValue(filterForm?.team),
  //     group: filterValue(filterForm?.group),
  //     date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
  //     date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
  //     is_cpd: true,
  //   };
  //   const reponse = await getRepFilter(request);
  //   const { code, data } = reponse.data;
  //   if (code === '200') {
  //     const dropdownValue = filterRepOptions(data);
  //     setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
  //   }
  // };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeMonth = (value) => {
    setFilterForm({ ...filterForm, month_year: moment(value).format('YYYY-MM') });
  };

  // useEffect(() => {
  //   loadTeamDropdown();
  //   loadRepDropdown();
  // }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        {/* <Grid md={2}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            options={teamOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Team' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MPR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid> */}
        <Grid md={2}>
          <DatePicker
            label='month_year'
            views={['month', 'year']}
            value={filterForm?.month_year}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => (
              <TextField {...params} label='Month Year' size='small' fullWidth />
            )}
            onChange={(value) => handleChangeMonth(value)}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={() => handleGenerateFilter()}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearFilter()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
